import { defineMessages } from 'react-intl';

/**
 * The copy of the one YouTube connection. The Channels card (Social) and the Catalog card
 * (Streaming) show the same sentences, because one Google sign-in feeds both.
 */
export const youtubeConnectionMessages = defineMessages({
  scope: {
    id: 'app.sml.youtube.connection.scopeConnections',
    defaultMessage: 'Posting and analytics. One YouTube connection for Connections and Catalog.',
  },
  // The native apps read the old Channels copy (navigation v2 renamed the page Connections).
  scopeNative: {
    id: 'app.sml.youtube.connection.scope',
    defaultMessage: 'Posting and analytics. One YouTube connection for Channels and Catalog.',
  },
  addAnalytics: {
    id: 'app.sml.youtube.connection.addAnalytics',
    defaultMessage:
      'Reconnect to add analytics. We post to YouTube for you, but Streaming cannot read your channel yet.',
  },
  addPosting: {
    id: 'app.sml.youtube.connection.addPosting',
    defaultMessage:
      'Reconnect to add posting. Streaming reads your channel, but we cannot post to YouTube for you yet.',
  },
  reconnect: {
    id: 'app.sml.youtube.connection.reconnect',
    defaultMessage: 'Reconnect',
  },
  disconnectBody: {
    id: 'app.sml.youtube.connection.disconnectBodyConnections',
    defaultMessage:
      'This disconnects YouTube for posting and for analytics, in Connections and in Catalog. Posts already booked wait for you to publish them. Social and Streaming keep the numbers we already read.',
  },
  // The native apps read the old Channels copy (navigation v2 renamed the page Connections).
  disconnectBodyNative: {
    id: 'app.sml.youtube.connection.disconnectBody',
    defaultMessage:
      'This disconnects YouTube for posting and for analytics, in Channels and in Catalog. Posts already booked wait for you to publish them. Social and Streaming keep the numbers we already read.',
  },
});
